// extracted by mini-css-extract-plugin
module.exports = {"outer":"_1cp3T","leftWrapper":"_3CQjv","heading":"_2ZIO1","subHeading":"_1dzU8","rightWrapper":"_3gU7S"};